export const DocumentTemplateType = {
  WORK_INSTRUCTION: 'workInstruction',
  STS_QUOTATION: 'stsQuotation',
}

export const DOCUMENT_TEMPLATE_TYPE_LABEL = {
  [DocumentTemplateType.WORK_INSTRUCTION]: 'Work Instruction Template',
  [DocumentTemplateType.STS_QUOTATION]: 'STS Quotation Template',
}

export const DOCUMENT_TEMPLATE_TYPE_OPTIONS = Object.entries(DOCUMENT_TEMPLATE_TYPE_LABEL).map(([value, label]) => ({
  value,
  label,
}))

export const DocumentTemplateTemplateType = {
  FILE: 'file',
  RICH_TEXT: 'richText',
}

export const DOCUMENT_TEMPLATE_TEMPLATE_TYPE_LABEL = {
  [DocumentTemplateTemplateType.FILE]: 'File',
  [DocumentTemplateTemplateType.RICH_TEXT]: 'Rich Text',
}

export const DocumentTemplateStatus = {
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  EXPIRED: 'expired',
}

export const DOCUMENT_TEMPLATE_STATUS_LABEL = {
  [DocumentTemplateStatus.SCHEDULED]: 'Scheduled',
  [DocumentTemplateStatus.ACTIVE]: 'Active',
  [DocumentTemplateStatus.EXPIRED]: 'Expired',
}

/**
 * The file extension a `file` template may hold for a given `type`, mirroring
 * `DOCUMENT_TEMPLATE_FILE_EXTENSIONS` in the server's documentTemplate.constant.ts.
 * Only `WORK_INSTRUCTION` has a generator today, and it only understands `.docx`.
 * `STS_QUOTATION` has no generator yet either, but is restricted to `.docx` in
 * anticipation of the same uploaded-letter pattern.
 */
export const DOCUMENT_TEMPLATE_FILE_ACCEPT = {
  [DocumentTemplateType.WORK_INSTRUCTION]: '.docx',
  [DocumentTemplateType.STS_QUOTATION]: '.docx',
}

/**
 * Types whose template has a signed copy, mirroring
 * `DOCUMENT_TEMPLATE_SIGNED_ONLY_VARIABLE_KEYS` in the server's
 * documentTemplate.constant.ts. These offer "Preview Sign" in Template Management.
 */
export const DOCUMENT_TEMPLATE_TYPES_WITH_SIGNED_PREVIEW = [DocumentTemplateType.WORK_INSTRUCTION]

export const VariableKind = {
  SCALAR: 'scalar',
  TABLE: 'table',
}

export const PaperSize = {
  A4: 'A4',
  LETTER: 'Letter',
}

export const Margin = {
  NORMAL: 'normal',
  NARROW: 'narrow',
  WIDE: 'wide',
}

export const PAPER_SIZE_OPTIONS = [
  { value: PaperSize.A4, label: 'A4 (210 × 297 mm)' },
  { value: PaperSize.LETTER, label: 'Letter' },
]

export const MARGIN_OPTIONS = [
  { value: Margin.NORMAL, label: 'Normal (20 mm)' },
  { value: Margin.NARROW, label: 'Narrow (12 mm)' },
  { value: Margin.WIDE, label: 'Wide (30 mm)' },
]

// Page geometry at 96dpi, so the canvas is a truthful preview of the paper the
// PDF will eventually be printed on.
export const PAPER_WIDTH_PX = {
  [PaperSize.A4]: 794,
  [PaperSize.LETTER]: 816,
}

export const MARGIN_PX = {
  [Margin.NORMAL]: 76,
  [Margin.NARROW]: 45,
  [Margin.WIDE]: 113,
}

export const DEFAULT_DOCUMENT_SETUP = {
  paperSize: PaperSize.A4,
  margins: Margin.NORMAL,
  footerText: '',
  showPageNumbers: true,
  includeSignatureBlock: false,
}

/**
 * Custom MIME type for dragging a variable chip into the document. A custom
 * type keeps the drop handler from reacting to arbitrary text dragged in from
 * elsewhere on the page.
 */
export const VARIABLE_DRAG_MIME = 'application/x-document-template-variable'
